// extracted by mini-css-extract-plugin
export default {"box":"index_box_WBBBV","footer":"index_footer_K-dQz"};